export default __webpack_public_path__ + "static/media/flight6.61b6152f.jpg";